import React from 'react'
import PropTypes from 'prop-types'
import Typo from 'constants/typography'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

const HowItWorksItem = ({ t, content: { desc, descKey, titleKey, title } }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <li className="pickup-hiw__item">
      <div className="pickup-hiw__item-title">
        <span className={Typo.h3}>
          {hasLocizeTranslation(t, titleKey, title)}
        </span>
      </div>
      <div className="pickup-hiw__item-description">
        <span className={Typo.subtitle1}>
          {hasLocizeTranslation(t, descKey, desc)}
        </span>
      </div>
    </li>
  </React.Fragment>
)

HowItWorksItem.propTypes = {
  t: PropTypes.func.isRequired,
  content: PropTypes.shape({
    desc: PropTypes.string.isRequired,
    descKey: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleKey: PropTypes.string.isRequired,
  }).isRequired,
}

export default HowItWorksItem
